import { Box, Button, Chip, Link } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'react-i18next';
import { round } from '@kheops/utils';
import PercentIcon from '../../assets/icons/percent.svg?react';
import { IntercomArticlesIds } from '../utils/intercom.articles.enum';

export interface CommissionInfoProps {
  commission: number;
  short?: boolean;
}

export default function CommissionInfo({ commission, short }: CommissionInfoProps): React.JSX.Element {
  const { t } = useTranslation(['common']);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 0.5,
      }}
    >
      <Chip variant="tag" icon={<PercentIcon />} label={` ${round(commission * 100)}%`} />
      {short
        ? (
          <Button variant="text" onClick={() => window.Intercom('showArticle', IntercomArticlesIds.Commissions)}>
            <InfoOutlinedIcon />
          </Button>
        )
        : (
          <Link
            onClick={() => window.Intercom('showArticle', IntercomArticlesIds.Commissions)}
            sx={{ color: 'onSurface.main' }}
          >
            {t('common:kheops_commission')}
          </Link>
        )}
    </Box>
  );
}
